import { Pipe, PipeTransform } from '@angular/core';
import { friendlyDateTime } from '../utils/ai-date.util';

/**
 * Template helper for friendly date/time rendering in Remmi AI views, e.g.
 * `{{ lead.follow_up_date | aiFriendlyDate }}` → "Tomorrow, 3:00 PM".
 *
 * Pass the backend time string as the argument when there is a separate time field:
 * `{{ item.due_date | aiFriendlyDate: item.task_time }}`.
 */
@Pipe({ name: 'aiFriendlyDate', standalone: true })
export class AiFriendlyDatePipe implements PipeTransform {
  transform(date?: string | null, time?: string | null): string {
    return friendlyDateTime(date, time);
  }
}
